import { createContext } from 'react';

export interface NotificationMethod {
    alert: (msg: string) => void;
}

export const GlobalNotificationContext = createContext<NotificationMethod>({} as any);
